// extracted by mini-css-extract-plugin
export const home = "index-module--home--1mM2Q";
export const planet = "index-module--planet--1f19y";
export const crow = "index-module--crow--wPbY7";
export const grid = "index-module--grid--XOURS";